<!--@format-->
<div *ngIf="selectedUser$ | async"></div>
<div *ngIf="currentUser$ | async"></div>
<div *ngIf="selectedUserAccountSetting$ | async"></div>

<div *ngIf="user$ | async as user">
   <div *ngIf="totalStrategiesMapped$ | async"></div>
   <div *ngIf="viewModel$ | async as viewModel">
      <div class="modal-header">
         <h3>
            <span *ngIf="isOnlyPreview || (!canEditDefault && !isOnlyPreview && user.selectedUser.userId === 0)"
               >Preview Template</span
            >
            <span *ngIf="!isOnlyPreview && (canEditDefault || user.selectedUser.userId !== 0)"
               >Edit Model / Template
            </span>
            <img style="height: 25px" src="/img/loading.gif" *ngIf="viewModel.loading" />
            <button
               type="button"
               class="close close-lg pull-right"
               aria-label="Close"
               (click)="onCancel(viewModel.templateUpdateModel.isModelUpdated, viewModel.errorMessage)"
            >
               <span aria-hidden="true">&times;</span>
            </button>
         </h3>
      </div>
      <div class="modal-body row preview-template">
         <div class="col-md-12 clearfloat" style="width: 99%; padding-bottom: 0px; min-height: 300px">
            <p-tabView
               (onChange)="selectedTab($event.index)"
               *ngIf="previewEditTemplate$ | async as previewEditTemplate"
            >
               <p-tabPanel *ngIf="!isOnlyPreview">
                  <ng-template pTemplate="header">Model</ng-template>
                  <preview-edit-model
                     [templateParameters]="templateParameters$ | async"
                     [previewEditTemplate]="previewEditTemplate"
                     [templateUpdateModel]="viewModel.templateUpdateModel"
                     [isMappedToOtherUser]="isMappedToOtherUser"
                     [selectedUserId]="user.selectedUser.userId"
                     [isOnlyPreview]="
                        isOnlyPreview || (!canEditDefault && !isOnlyPreview && user.selectedUser.userId === 0)
                     "
                     [requireVoiceFirstNameTTS]="requireVoiceFirstNameTTS"
                     [templateId]="selectedTemplateId"
                     [userPermissions]="user.selectedUser.userPermissions"
                     [communicationsCategoryId]="selectedTemplate.communicationsCategoryId"
                     [activeIndex]="activeIndex"
                     *ngIf="activeIndex === 0"
                  ></preview-edit-model>
               </p-tabPanel>
               <p-tabPanel header="Preview">
                  <ng-template pTemplate="content">
                     <preview-edit-template
                        [template]="selectedTemplate"
                        [templateId]="selectedTemplateId"
                        [templateParameters]="templateParameters$ | async"
                        [selectedUserId]="user.selectedUser.userId"
                        [isOnlyPreview]="
                           isOnlyPreview || (!canEditDefault && !isOnlyPreview && user.selectedUser.userId === 0)
                        "
                        [templateUpdateModel]="viewModel.templateUpdateModel"
                        [templateFileRef]="updatedTemplateFileRef"
                        [previewMediaType]="previewMediaType"
                        [hasValueFromDb]="hasValueFromDb"
                        [userPermissions]="user.selectedUser.userPermissions"
                        [communicationsCategoryId]="categoryType"
                        [activeIndex]="activeIndex"
                        [disablePasteEvent]="disablePasteEvent"
                     ></preview-edit-template>
                  </ng-template>
               </p-tabPanel>
               <p-tabPanel header="Source" *ngIf="!isOnlyPreview">
                  <!--A TabPanel is specified as lazy when there is a ngTemplate with pTemplate="content" in it. -->
                  <ng-template pTemplate="content">
                     <preview-edit-source
                        [emailSource]="emailSource$ | async"
                        (isSourceChange)="sourceChanged($event)"
                        [selectedUserName]="user.selectedUser.userName"
                        [selectedUserId]="user.selectedUser.userId"
                        [updatedModel]="viewModel.templateUpdateModel.updatedModel"
                        [selectedTemplateId]="selectedTemplateId"
                        (templateFileRefChange)="templateFileRefChange($event)"
                        [isOnlyPreview]="
                           isOnlyPreview || (!canEditDefault && !isOnlyPreview && user.selectedUser.userId === 0)
                        "
                        [selectedTemplate]="selectedTemplate"
                     ></preview-edit-source>
                  </ng-template>
               </p-tabPanel>
               <p-tabPanel
                  header="Media/Devices"
                  *ngIf="canEditDefault || (!isOnlyPreview && user.selectedUser.userId !== 0)"
               >
                  <template-media
                     [selectedUserId]="user.selectedUser.userId"
                     [templateMedia]="previewEditTemplate.media"
                     (isMediaChanged)="isMediaChanged($event)"
                  ></template-media>
               </p-tabPanel>
               <p-tabPanel
                  header="Send Test Message"
                  *ngIf="canEditDefault || (!isOnlyPreview && user.selectedUser.userId !== 0)"
               >
                  <ng-template pTemplate="content">
                     <template-send-message
                        [templateId]="selectedTemplateId"
                        [testMediaDevices]="viewModel.mediaDevices"
                        [selectedTemplate]="selectedTemplate"
                        [updatedModel]="viewModel.templateUpdateModel.updatedModel"
                        [isSourceChanged]="isSourceChanged"
                        [templateFileRef]="updatedTemplateFileRef"
                        [locations]="locationEntities$ | async"
                        [providers]="providers$ | async"
                        [appointmentResources]="appointmentResources$ | async"
                        [reasons]="reasons$ | async"
                        [selectedUser]="user.selectedUser.userId !== 0 ? user.selectedUser : user.currentUser"
                     ></template-send-message>
                  </ng-template>
               </p-tabPanel>
            </p-tabView>
         </div>
      </div>

      <div class="modal-footer">
         <span *ngIf="fileModel !== undefined && fileModel.templateId && !isOnlyPreview" style="color: #f5a207"
            >Changes are not saved to the database until accepting to replace the file</span
         >
         <div
            *ngIf="!canEditDefault && !isOnlyPreview && user.selectedUser.userId !== 0"
            style="color: #f5a207; text-align: left; font-size: 12px"
         >
            <span *ngIf="isMappedToOtherUser">
               <span style="font-weight: 600">Template</span> used by other users. Saving model changes will be done in
               a clone (using same file) assigned to the user.<br />
            </span>
            <span *ngIf="isFileUsedByOtherUser"
               ><span style="font-weight: 600">File</span> used by other users. Saving file changes will be done in a
               clone (using new file) assigned to the user.</span
            >
         </div>
         <div
            *ngIf="!canEditDefault && !isOnlyPreview && user.selectedUser.userId === 0"
            style="color: #ff3131; text-align: left"
         >
            <span *ngIf="isMappedToOtherUser">
               <span class="glyphicon glyphicon-lock" aria-hidden="true"></span>
               Editing is not possible. The template is used by at least one user <br />
            </span>

            <span *ngIf="!isMappedToOtherUser && !canEditDefault">
               <span class="glyphicon glyphicon-lock" aria-hidden="true"></span>
               Editing is not possible. No user is selected <br />
            </span>

            No user selected so template preview will not display user specific settings (e.g. logo) and sending test
            messages is not possible.
         </div>

        <div
            *ngIf="getIsPnovaVoiceMediaType()"
            style="color: #f5a207; text-align: left; font-size: 12px"
        >
          <span style="font-weight: 600">The media device selected is not supported. Please select voice|twilio|0 instead.</span>
        </div>


        <div style="color: #ff3131; text-align: left; font-size: 12px" *ngIf="canEditDefault">
            <span style="font-weight: 600"
               >You are making changes in Default template.
               <span *ngIf="isMappedToOtherUser"> The template is used by at least one user </span>
            </span>
            <br />
         </div>

         <div
            class="row"
            *ngIf="
               (viewModel.templateUpdateModel.isModelUpdated || isSourceChanged || isMediaUpdated) &&
               !isOnlyPreview &&
               (!canEditDefault || user.selectedUser.userId !== 0)
            "
         >
            <div class="col-md-12" style="text-align: left">
               <span *ngIf="viewModel.templateUpdateModel.isModelUpdated" style="color: #2a91bd">Model edited</span>
               <span *ngIf="viewModel.templateUpdateModel.isModelUpdated && isMediaUpdated"> &mdash; </span>
               <span *ngIf="isMediaUpdated" style="color: #2a91bd">Media edited</span>
               <span *ngIf="viewModel.templateUpdateModel.isModelUpdated && isSourceChanged"> &mdash; </span>
               <span *ngIf="isSourceChanged" style="color: #2a91bd">Template file edited</span>
            </div>
         </div>

         <div class="row" *ngIf="viewModel.errorMessage">
            <div class="col-md-12" style="text-align: left">
               <div *ngIf="viewModel.errorMessage !== undefined">
                  <span style="color: #ff3131">{{ viewModel.errorMessage }}</span>
               </div>
            </div>
         </div>

         <ng-container *ngIf="!(isSaving$ | async); else savinButtonContainer">
            <button
               *ngIf="displayConversionSMS$ | async"
               class="btn btn-primary"
               aria-hidden="true"
               style="margin-right: 16px"
               (click)="triggerConversionSMS()"
               tooltip="Convert AR2-tag into AR3-tag"
            >
               Convert SMS Tags
            </button>
            <button
               class="btn btn-primary"
               aria-hidden="true"
               (click)="openAdaptiveRulesDialog(user.selectedUser.userId)"
               style="margin-right: 16px"
               [disabled]="
                  (!canEditDefault && (user.selectedUser.userId === undefined || user.selectedUser.userId === 0)) ||
                  !canAccessAdaptive
               "
            >
               {{ "_Preview_Template_Adaptive_" | translate }}
            </button>
            <button
               *ngIf="!isOnlyPreview && !shouldSaveAsCustom(user.selectedUser.userId)"
               class="btn btn-primary"
               aria-hidden="true"
               (click)="
                  saveChanges(
                     user.selectedUser.userId,
                     viewModel.templateUpdateModel.updatedModel,
                     viewModel.templateUpdateModel.isModelUpdated,
                     viewModel.mediaDevices
                  )
               "
               style="margin-right: 16px"
               [disabled]="
                  viewModel.errorMessage !== undefined ||
                  (!isSourceChanged && !isMediaUpdated && !viewModel.templateUpdateModel.isModelUpdated) ||
                  (!canEditDefault && isMappedToOtherUser) ||
                  requireVoiceFirstNameTTS ||
                  (!canEditDefault && (user.selectedUser.userId === undefined || user.selectedUser.userId === 0)) ||
                   getIsPnovaVoiceMediaType()
               "
            >
               Save Changes
            </button>
            <button
               *ngIf="!isOnlyPreview && shouldSaveAsCustom(user.selectedUser.userId)"
               class="btn btn-primary"
               aria-hidden="true"
               (click)="
                  saveAsCustomTemplate(
                     user.selectedUser.userId,
                     viewModel.templateUpdateModel.updatedModel,
                     viewModel.mediaDevices
                  )
               "
               style="margin-right: 16px"
               [disabled]="
                  viewModel.errorMessage !== undefined ||
                  (!isSourceChanged && !isMediaUpdated && !viewModel.templateUpdateModel.isModelUpdated) ||
                  requireVoiceFirstNameTTS ||
                  user.selectedUser.userId === undefined ||
                  user.selectedUser.userId === 0
               "
            >
               Save as Custom Template
            </button>
            <div class="pull-right">
               <button
                  class="btn btn-default btn-cancel"
                  (click)="onCancel(viewModel.templateUpdateModel.isModelUpdated, viewModel.errorMessage)"
               >
                  <span *ngIf="viewModel.templateUpdateModel.isModelUpdated && viewModel.errorMessage === undefined"
                     >Cancel</span
                  >
                  <span *ngIf="!viewModel.templateUpdateModel.isModelUpdated || viewModel.errorMessage !== undefined"
                     >Close</span
                  >
               </button>
            </div>
         </ng-container>

         <ng-template #savinButtonContainer>
            <button
               *ngIf="displayConversionSMS$ | async"
               class="btn btn-primary"
               aria-hidden="true"
               style="margin-right: 16px"
               tooltip="Convert AR2-tag into AR3-tag"
               disabled
            >
               Convert SMS Tags
            </button>
            <button class="btn btn-primary" aria-hidden="true" style="margin-right: 16px" disabled>
               {{ "_Preview_Template_Adaptive_" | translate }}
            </button>
            <button
               *ngIf="!isOnlyPreview && !shouldSaveAsCustom(user.selectedUser.userId)"
               class="btn btn-primary"
               aria-hidden="true"
               style="margin-right: 16px"
               disabled
            >
               Saving changes...
               <img src="img/loading.gif" width="16px" alt="saveChanges" />
            </button>
            <button
               *ngIf="!isOnlyPreview && shouldSaveAsCustom(user.selectedUser.userId)"
               class="btn btn-primary"
               aria-hidden="true"
               style="margin-right: 16px"
               disabled
            >
               Saving as Custom Template...
               <img src="img/loading.gif" width="16px" alt="saveChanges" />
            </button>
            <div class="pull-right">
               <button class="btn btn-default btn-cancel" disabled>Close</button>
            </div>
         </ng-template>
      </div>
   </div>
</div>
